import * as React from 'react';
import { GrGroup } from "react-icons/gr";
import { IoIosPricetags } from "react-icons/io";
import { IoClose, IoLayersOutline } from "react-icons/io5";
import { getAllMembers, getProjectById, logout } from '../../../service/service-call';

export default function ViewProjects({ viewProjectModal, project }) {
  const [allAdmins, setAllAdmins] = React.useState([]);
  const [allMembers, setAllMembers] = React.useState([]);
  const [tname, setTName] = React.useState('');
  const [projectId, setProjectId] = React.useState('');
  const [selectedOption, setSelectedOption] = React.useState("");
  const [selectedProjectMembers, setSelectedProjectMembers] = React.useState([]);
  const [selectedProjectMemberIds, setSelectedProjectMemberIds] = React.useState([]);

  React.useEffect(() => {
    getProjectById(project.id).then(resp => {
      if (resp.status === 401) {
        logout();
      }
      resp.json().then(data => {
        console.log(data);
        setTName(data.projectName);
        let arr = [];
        data?.members && data?.members?.length > 0 && data.members?.map((option) => arr.push(option.firstName + " " + option.lastName + " (" + option.id + ")"));
        setSelectedProjectMembers(arr);
      });
    }).catch(error => {
      console.log("login user err " + error);
    });
  }, []);

  React.useEffect(() => {
    getAllAdmins();
    getAllMemberForProject();
  }, []);

  function getAllAdmins() {
    getAllMembers("").then(resp => {
      if (resp.status === 401) {
        logout();
      }
      resp.json().then(data => {
        setAllAdmins(data);
      });
    }).catch(error => {
      console.log("login user err " + error);
    });
  }

  function getAllMemberForProject() {
    getAllMembers("").then(resp => {
      if (resp.status === 401) {
        logout();
      }
      resp.json().then(data => {
        setAllMembers(data);
      });
    }).catch(error => {
      console.log("login user err " + error);
    });
  }

  if (!project || !project.projectName) return null;

  return (
    <div className="relative flex flex-col">
      {/* Header */}
      <div className="relative bg-gradient-to-r from-[#1b1b3a] to-[#262673] px-6 py-5 text-center">
        <button
          onClick={() => viewProjectModal(null)}
          className="absolute right-4 top-4 flex h-7 w-7 items-center justify-center rounded-full text-white/60 transition-colors hover:bg-white/10 hover:text-white"
        >
          <IoClose size={18} />
        </button>
        <p className="text-sm font-bold tracking-wide text-white">{project.projectName.toUpperCase()}</p>
      </div>

      {/* Description */}
      {project.description && (
        <div className="border-b border-gray-100 px-6 py-4">
          <p className="text-sm text-gray-600">{project.description}</p>
        </div>
      )}

      <div className="max-h-[400px] overflow-y-auto px-6 py-5">
        {/* Tags */}
        {project.tags && project.tags.length > 0 && (
          <div className="mb-5">
            <p className="mb-2 flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-gray-400">
              <IoIosPricetags size={13} />
              Tags
            </p>
            <div className="flex flex-wrap gap-1.5">
              {project.tags.map((each, ind) => (
                <span
                  key={ind}
                  className="flex items-center gap-1 rounded-md border border-gray-200 px-2.5 py-1 text-xs font-medium text-[#262673]"
                >
                  <IoIosPricetags size={11} />
                  {each.name}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Teams */}
        {project.teams && project.teams.length > 0 && (
          <div>
            <p className="mb-2 flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-gray-400">
              <GrGroup size={13} />
              Teams
            </p>
            <div className="flex flex-wrap gap-1.5">
              {project.teams.map((each, ind) => (
                <span
                  key={ind}
                  className="flex items-center gap-1 rounded-md bg-[#262673] px-2.5 py-1 text-xs font-medium text-white"
                >
                  <GrGroup size={11} />
                  {each.teamName.toUpperCase()}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Empty state */}
        {(!project.tags || project.tags.length === 0) && (!project.teams || project.teams.length === 0) && (
          <div className="flex flex-col items-center justify-center gap-1 py-10 text-gray-300">
            <IoLayersOutline size={22} />
            <p className="text-xs font-medium">No tags or teams assigned</p>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="border-t border-gray-100 px-6 py-3 text-right">
        <button
          onClick={() => viewProjectModal(null)}
          className="rounded-lg px-4 py-2 text-sm font-semibold text-orange-500 transition-colors hover:bg-orange-50"
        >
          Close
        </button>
      </div>
    </div>
  );
}